module.exports = __webpack_public_path__ + "img/ram.2a6d0dad.png";